// extracted by mini-css-extract-plugin
export default {"typography":"Typography_typography__X6FT8","typography--cropped":"Typography_typography--cropped__ALYW4"};